<script lang="ts" context="module">
  import { page } from '$app/stores';
  import { preferencesDialog } from '$components/PreferencesModal.svelte';
  import { writable } from 'svelte/store';

  export type Tab = 'Customise Layouts' | 'Site Config' | 'Alerts' | 'Betting';
  export let tabs = [
    'Site Config',
    'Customise Layouts',
    'Alerts',
    'Betting'
  ] as Tab[];
  export const activeTab = writable(tabs[0]);
  export const openPreferencesTab = (tab: Tab) => {
    activeTab.set(tab);
    preferencesDialog.open();
  };
</script>

<script lang="ts">
  function handleChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    const value = target.value;
    openPreferencesTab(value as Tab);
  }
  // add extra tabs in depending on feature flags
  // $: ({ featureFlags } = $page.data);
  // $: if ($featureFlags?.includes('bet_prefill') && !tabs.includes('Betting')) {
  //   tabs.push('Betting');
  // }
</script>

<div class="sm:hidden">
  <label for="tabs" class="sr-only">Select a tab</label>
  <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
  <select
    on:change={handleChange}
    id="tabs"
    name="tabs"
    class="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"
  >
    {#each tabs as tab}
      <option value={tab}>{tab}</option>
    {/each}
  </select>
</div>
<div class="hidden border-b pb-3 sm:block">
  <nav class="flex space-x-4" aria-label="Tabs">
    {#each tabs as tab}
      <button
        class={`
                ${
                  $activeTab === tab
                    ? 'rounded-md bg-indigo-100 text-sm font-semibold text-indigo-700 hover:bg-indigo-50'
                    : 'rounded-md  text-sm font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-700'
                }
                group inline-flex items-center px-3 py-2`}
        aria-current={$activeTab === tab ? 'page' : undefined}
        on:click={() => openPreferencesTab(tab)}
      >
        {tab}
      </button>
    {/each}
  </nav>
</div>
